import {
  Email,
  LocalPhone,
  MarkUnreadChatAltOutlined,
  TextsmsOutlined,
} from '@mui/icons-material'
import { Box, Stack, Typography, alpha, useTheme } from '@mui/material'

import rem from '~/utils/ui'

function Help247Page() {
  const theme = useTheme()

  return (
    <Stack
      sx={{
        height: '100vh',
      }}
    >
      <Stack
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          paddingBlock: rem(30),
          backgroundColor: theme.palette.mainFont,
          '& p': {
            color: theme.palette.common.white,
          },
        }}
      >
        <Typography
          sx={{
            fontSize: { xxxs: rem(14), sm: rem(18) },
          }}
        >
          Welcome to
        </Typography>
        <Typography
          sx={{
            fontSize: { xxxs: rem(28), sm: rem(60) },
          }}
        >
          help247.ai
        </Typography>
      </Stack>
      <Stack
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          gap: rem(30),
          padding: rem(15),
        }}
      >
        <Stack
          sx={{
            '& p': {
              fontSize: { xxxs: rem(30), sm: rem(51) },
              fontWeight: theme.typography.fontWeightLight,
              textAlign: 'center',
            },
          }}
        >
          <Typography>
            We are your AI Receptionist. <br /> We will respond to
          </Typography>
        </Stack>

        <Stack
          sx={{
            backgroundColor: alpha(theme.palette.tertiary1, 0.1),
            padding: `${rem(20)} ${rem(40)}`,
            borderRadius: rem(7),
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: { xxxs: rem(22), sm: rem(40) },
            justifyContent: 'center',

            '& div': {
              display: 'flex',
              alignItems: 'center',
              gap: rem(8),
              fontSize: rem(20),
              '& svg': {
                color: theme.palette.tertiary1,
              },
            },
          }}
        >
          <Box>
            <LocalPhone />
            Calls
          </Box>
          <Box>
            <Email /> Emails
          </Box>
          <Box>
            <MarkUnreadChatAltOutlined />
            Texts
          </Box>
          <Box>
            <TextsmsOutlined /> Chats
          </Box>
        </Stack>
        <Typography
          sx={{
            fontSize: { xxxs: rem(20), sm: rem(31) },
            paddingTop: rem(40),
          }}
        >
          Contact us at ###-###-####
        </Typography>
      </Stack>
    </Stack>
  )
}
export default Help247Page
